<template>
  <div class="invite-list">
    <van-tabs v-model="active" color="#0639EF" @change="onTabsChange" sticky>
      <van-tab :title="`已确认（${invitedCount}）`">
        <template v-if="invitedList && invitedList.length">
          <Invited :list="invitedList" @delete="onDelete" />
        </template>
        <template v-if="invitedList && !invitedList.length">
          <Empty class="empty" />
        </template>
      </van-tab>
      <van-tab :title="`待确认（${penddingCount}）`">
        <template v-if="penddingList && penddingList.length">
          <Pendding :list="penddingList" @sure="onSure" />
        </template>
        <template v-if="penddingList && !penddingList.length">
          <Empty class="empty" />
        </template>
      </van-tab>
    </van-tabs>

    <Loading v-model="loading" />
  </div>
</template>

<script>
  import Pendding from './components/Pendding'
  import Invited from './components/Invited'
  import Loading from '@/components/Loading'
  import Empty from '@/components/Empty'

  import { mapGetters} from 'vuex'

  export default {
    components: {
      Pendding,
      Invited,
      Loading,
      Empty
    },
    data() {
      return {
        active: 1,
        loading: false,
        invitedLoading: false,
        invitedList: null,
        penddingList: null,
        invitedCount: 0,
        penddingCount: 0,
      }
    },
    computed: {
      ...mapGetters(['appId', 'exhibitionId', 'languageType', 'subjectType', 'terminal']),
      queryParams() {
        return {
          appId: this.appId,
          exhibitionId: this.exhibitionId,
          languageType: this.languageType,
          subjectType: this.subjectType,
          terminal: this.terminal
        }
      },
      isVisitor() {
        return this.subjectType === 'VISITOR'
      }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        this.getUrlParams()

        if (this.active === 0) {
          this.getData()
        } else {
          if (this.isVisitor) {
            this.getPenddingVisitor()
          } else {
            this.getPendding()
          }
        }
        this.getNum()
      },
      getUrlParams() {
        const query = this.$route.query

        this.$store.commit('changeToken', decodeURIComponent(query.token))
        this.$store.commit('changeExhibitionId', query.exhibitionId)
        this.$store.commit('changeAppID', query.appId)
        this.$store.commit('changeSubjectType', query.subjectType)
        this.$store.commit('changeTerminal', query.terminal || 'wechat')
      },
      getData() {
        let showType = ''
        let requestFn
        if (this.isVisitor) {
          showType = 'PERSON_LIST'
          requestFn = this.$http.newContactPersonList
        } else {
          showType = 'ACTOR_LIST'
          requestFn = this.$http.contactPersonList
        }

        const params = {
          ...this.queryParams,
          showType,
          contactState: '',
          intention: '',
          applicationId: 1,
          keyword: '',
          timeSort: 'CREATE',
          pageNum: 1,
          pageRows: 999999
        }
        this.loading = true

        requestFn(params).then(res => {
          if (res.code === 1000) {
            const data = res.data
            this.loading = false
            this.invitedList = data.list || []
          }
        })
      },
      getPendding() {
        const params = {
          ...this.queryParams,
          pageNum: 1,
          pageRows: 999999
        }
        this.loading = true
        this.$http.inviteRecordList(params).then(res => {
          if (res.code === 1000) {
            const data = res.data
            this.loading = false
            this.penddingList = data.list || []
          }
        })
      },
      getPenddingVisitor() {
        const params = {
          ...this.queryParams,
          attendTimes: "DESC",
          companyScale: "NO",
          pageNum: 1,
          pageRows: 999999,
          registeredCapital: "",
          showType: "PERSON_LIST"
        }

        this.loading = true
        this.$http.inviteRecordListVisitor(params).then(res => {
          if (res.code === 1000) {
            const data = res.data
            this.loading = false
            this.penddingList = data.list || []
          }
        })
      },
      onSure(item) {
        const params = {
          ...this.queryParams,
          projectId: item.projectId,
          id: item.id,
        }

        this.loading = true
        this.$http.newConfirmInviteRecord(params).then(res => {
          if (res.code === 1000) {
            this.loading = false
            this.$Toast.success('已确认')
            this.getNum()
            this.getPendding()
          }
        })
      },
      onDelete(item) {
        const params = {
          ...this.queryParams,
          id: item.id
        }
        this.$http.deleteContactPerson(params).then(res => {
          if (res.code == 1000) {
            this.$Toast.success('删除成功')
            this.getData()
            this.getNum()
          }
        })
      },
      getNum() {
        const params = {
          ...this.queryParams,
        }
        this.$http.getNum(params).then(res => {
          if (res.code == 1000) {
            const data = res.data
            this.penddingCount = data.inviteRecordNum;
            this.invitedCount = data.contactPersonNum;
          }
        })
      },
      onTabsChange(e) {
        if (this.active === 0) {
          this.getData()
        } else {
          if (this.isVisitor) {
            this.getPenddingVisitor()
          } else {
            this.getPendding()
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .invite-list {
    width: 100%;
    min-height: 100vh;
    max-width: 750px;
    margin: 0 auto;
  }
  .empty {
    height: calc(100vh - 44px);
  }
</style>
